// src/com/dc_and_store/DcAndStore.js
import React, { useEffect, useState } from 'react';
import TopViewControl from '../../common/TopViewControl';
import ServiceTabs from '../menu_info/ServiceTabs';
import { menuRequestRepo } from '../../value/AppModel';
import DcInfo from '../dc_info/DcInfo';
import ArriveInfo from '../arrive_info/ArriveInfo';
import ComInfo from '../com_info/ComInfo';
import { AppMenuUrl } from '../../value/AppConst';

export default function DcAndStore({
    menu, parentMenu
}) {
    const [mountedViews, setMountedViews] = useState(() => ({
        [menu.menuUrl]: true,
    }));

    useEffect(() => {
        setMountedViews((prev) => {
            if(prev[menu.menuUrl]) return prev;
            return {...prev, [menu.menuUrl]: true};
        });
    }, [menu.menuUrl]);

    const onChangeTab = (v) => {
        const sib = parentMenu.children.find((child) => child.menuId === v);
        if(sib) {
            setMountedViews((prev) => {
                if(prev[sib.menuUrl]) return prev;
                return {...prev, [sib.menuUrl]: true};
            });
        }
        menuRequestRepo({menu:sib, parentMenu:parentMenu});
    };

    const viewServiceTags = <ServiceTabs menu={menu} parentMenu={parentMenu} onChangeTab={onChangeTab} />;

    // 출발지, 도착지, 운송사 정보
    return(
        <TopViewControl>
            {mountedViews[AppMenuUrl.DCInfo] &&
                <DcInfo
                    viewServiceTags={viewServiceTags}
                    show={menu.menuUrl===AppMenuUrl.DCInfo}
                />
            }
            {mountedViews[AppMenuUrl.ArriveInfo] &&
                <ArriveInfo
                    viewServiceTags={viewServiceTags}
                    show={menu.menuUrl===AppMenuUrl.ArriveInfo}
                />
            }
            {mountedViews[AppMenuUrl.ComInfo] &&
                <ComInfo
                    viewServiceTags={viewServiceTags}
                    show={menu.menuUrl===AppMenuUrl.ComInfo}
                />
            }
        </TopViewControl>
    );
}